import * as THREE from "three"
import Experience from "./Experience.js"

export default class Renderer {
    constructor() {
        this.experience = new Experience()
        this.canvas = this.experience.canvas
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.camera = this.experience.camera

        this.setInstance()
    }

    setInstance() {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
            physicallyCorrectLights: true,
            shadowMap: {
                enabled: true,
                type: THREE.PCFSoftShadowMap
            },
            toneMapping: THREE.ACESFilmicToneMapping
        })

        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(Math.min(this.sizes.devicePixelRatio, 1.75))
        this.instance.outputEncoding = THREE.sRGBEncoding
        this.instance.toneMappingExposure = 1.22
        this.instance.setClearColor('#182532')
        this.instance.shadowMap.enabled = true
        this.instance.shadowMap.type = THREE.PCFSoftShadowMap
    }

    resize() {
        this.instance.setSize(this.sizes.width, this.sizes.height)
        this.instance.setPixelRatio(Math.min(this.sizes.devicePixelRatio, 1.75))
    }

    update() {
        this.instance.render(this.scene, this.camera.instance)
    }
}